import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import IConsultantProfile from "@skills-app/models/consultant-profile";

@Component({
  standalone: false,
  selector: "app-profile-download-button",
  templateUrl: "./profile-download-button.component.html",
  styleUrls: ["./profile-download-button.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileDownloadButtonComponent {
  @Input() userProfile: IConsultantProfile | null = null;
  @Input() templateTypes: string[] = [];
  @Input() isDownloadEnabled: boolean | null | undefined = true;

  @Output() downloadProfile = new EventEmitter<{
    userProfile: IConsultantProfile;
    templateType: string;
  }>();

  emitDownload(templateType: string): void {
    if (!this.userProfile) return;

    this.downloadProfile.emit({
      userProfile: this.userProfile,
      templateType,
    });
  }
}
